/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useCallback,
  useState,
  useRef,
  useMemo,
  useEffect,
} from "react";
import Text from "@components/CustomText";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import {
  cancelRto,
  getQrCodeStatus,
  getUserOrders,
  markMultipleDeliveries,
  markTaskActions,
} from "@services/api";
import color from "@constants/color";
import {
  Alert,
  BackHandler,
  FlatList,
  View,
  StyleSheet,
  ActivityIndicator,
  Modal,
  TextInput,
  TouchableOpacity,
  KeyboardAvoidingView,
  Platform,
} from "react-native";
import { width } from "@utils/metrics";
import imagePickerHelper from "@utils/imagePickerHelper";
import { useFocusEffect } from "@react-navigation/native";
// eslint-disable-next-line import/no-named-as-default
import t from "@constants/localization";
import { useCachedLocation } from "@components/common/LocationHook";
import ConfirmationModalWithImage from "@components/ConfirmationModalWithImage";
import ModalSubmit from "@assets/svg/MyTasks/ModalSubmit";
import ModalCancel from "@assets/svg/MyTasks/ModalCancel";
import ModalCashCollection from "@assets/svg/MyTasks/ModalCashCollected";
import { useDispatch, useSelector } from "react-redux";
import { actions as myTaskActions } from "@reducers/myTaskReducer";
import ToastMessage from "@components/Toast.js";
import analytics from "@services/analytics";
import CashIcon from "@assets/svg/MyTasks/Cash";
import QRIcon from "@assets/svg/MyTasks/QRIcon";
import InnerDeliveryCard from "./components/InnerDeliveryCard";
import RescheduleRightComponent from "./components/RescheduleRightComponent";
import RescheduleModal from "./components/RescheduleModal";
import MarkingDeliveryModal from "./components/MarkingDeliveryModal";
import BottomButton from "./components/BottomButton";
import CompleteDelivery, {
  DEFAULT_COMPLETE_DELIVERY_DATA,
} from "./OtpVerifcation/CompleteDelivery";
import BottomPaymentSheet from "./components/BottomPaymentSheet";
import {
  calculateTotalPayableAmount,
  buildDeliveryProofPayload,
} from "./utils";
import EmptyBox from "@assets/svg/EmptyBox";
import CloseIcon from "@assets/svg/CloseIcon";
import DeliveryProofImageGrid from "./components/DeliveryProofImageGrid";
import uuid from "react-native-uuid";
import { getBuildNumber } from "react-native-device-info";
import { resolveValidationConfig } from "@utils/proofValidationConfig";

const HeaderStrip = ({ should_deliver_tag }) => (
  <View style={styles.headerStrip}>
    <EmptyBox />
    <Text variant="title_16" style={styles.headerText}>
      {should_deliver_tag}
    </Text>
  </View>
);

// Stable per-delivery key for the poly-bag modal's pre-fill guard: a retained
// photo/count is only re-offered when the CP returns to the SAME order.
const plasticBagOrderKey = (d) => String(d?.order_ids?.[0] ?? d?.user_id ?? "");

// Stable snapshot of the per-order marking map: sort outer keys so a re-ordered
// (but equal) map serializes identically; the snapshot changes only when a
// marking's value actually changes.
const stableMarkingSnapshot = (map) =>
  JSON.stringify(
    Object.keys(map)
      .sort()
      .map((k) => [k, map[k]]),
  );

function CustomerOrdersView({ navigation, route }) {
  const { orderMarkingMap, orderMarkingSource } = useSelector(
    (state) => state.myTaskReducer,
  );
  const [allData, setAllData] = useState({});
  const [listData, setListData] = useState([]);
  const [isloading, setIsLoading] = useState(true);
  const [isRescheduled, setIsRescheduled] = useState(null);
  const [isPendingDMinus2, setIsPendingDMinus2] = useState(false);
  const [rescheduledModal, setRescheduledModal] = useState(false);
  const isRescheduledCp = useRef(false);
  const [showMarkingModal, setShowMarkingModal] = useState(false);
  const [markingOrder, setMarkingOrder] = useState(null);
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [showCancleMarkingModal, setShowCancleMarkingModal] = useState(false);
  const [showCompleteDeliveryModal, setShowCompleteDeliveryModal] =
    useState(false);
  const [completeDeliveryData, setCompleteDeliveryData] = useState(
    DEFAULT_COMPLETE_DELIVERY_DATA,
  );
  const {
    multiOrderDelivery = false,
    pollingEnable = false,
    pollingInterval = 30,
  } = useSelector(({ configReducer }) => configReducer);
  // Tier 1 of the image-validation config (GET /cpdb/setup-5). Persisted, so it
  // survives a failed boot fetch — which is exactly why it is not the only
  // lever. See @utils/proofValidationConfig.
  const appSettings = useSelector(
    ({ configReducer }) => configReducer?.appSettings,
  );
  const [multiDeliveryEnabled, setMultiDeliveryEnabled] = useState(
    multiOrderDelivery || false,
  );

  const [onlinePaymentMetadata, setOnlinePaymentMetadata] = useState({});
  const [showPlasticBagModal, setShowPlasticBagModal] = useState(false);
  const pendingPaymentModeRef = useRef(null);
  const plasticBagDataRef = useRef(null);
  const plasticBagOrderKeyRef = useRef(null);
  const plasticBagMarkingSnapshotRef = useRef(null);
  const plasticBagProceedRef = useRef(false);
  // Holds {popup_variant, images} across the OTP/QR nav round-trip, mirroring
  // plasticBagDataRef.
  const deliveryProofDataRef = useRef(null);

  const [deliveryProofImages, setDeliveryProofImages] = useState([]);
  const [plasticBagDeliveredCount, setPlasticBagDeliveredCount] = useState("");
  const [isUploadingImage, setIsUploadingImage] = useState(false);

  const data = route.params?.data;

  const PATH = "screens/MyTask";

  const isMarking = useRef(false);
  const isProcessingRef = useRef(false);
  const isFirstVisit = useRef(true);
  const isSubmitted = useRef(false);
  const hasNavigatedToOtpRef = useRef(false);
  const cardMarkingBtnRef = useRef(false);
  const isMountedRef = useRef(true);
  // Cache-only on purpose: this screen must never trigger a fresh movex.geo
  // fix. Coordinates come from state.location.lastFix — seeded by the tracking
  // stream and by MyTasks' own capture on focus, never captureCurrentPosition
  // here. See docs/flows/location-capture-and-transmission.md.
  const getCachedLocation = useCachedLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (showPlasticBagModal) {
      try {
        analytics.trackEvent("Plastic Bag Popup Open", {
          popup_variant: popupConfig?.popup_variant ?? null,
        });
      } catch (_e) {
        // swallow analytics errors
      }
    }
  }, [showPlasticBagModal, popupConfig]);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useFocusEffect(
    useCallback(() => {
      if (
        !isFirstVisit.current &&
        multiDeliveryEnabled &&
        !isSubmitted.current
      ) {
        if (hasNavigatedToOtpRef.current) {
          // Returning from OTP screen after a failed/cancelled attempt — keep
          // existing markings intact, don't re-open the marking modal.
          hasNavigatedToOtpRef.current = false;
        } else if (markingOrder) {
          setShowMarkingModal(true);
        }
      } else {
        isFirstVisit.current = false;
        dispatch(myTaskActions.clearOrderMarking());
      }
      fetchData();
    }, [markingOrder]),
  );
  useFocusEffect(
    useCallback(() => {
      const subscription = BackHandler.addEventListener(
        "hardwareBackPress",
        backHandler,
      );

      return () => {
        subscription.remove();
      };
    }, [orderMarkingMap]),
  );
  useEffect(() => {
    if (!pollingEnable) return;
    let intervalId = null;
    const checkStatus = async () => {
      await getPaymentStatus();
    };
    if (
      Object.keys(orderMarkingMap).length > 0 &&
      allData?.online_payment_enabled &&
      (onlinePaymentMetadata?.payment_status === "CREATED" ||
        onlinePaymentMetadata?.payment_status === "PENDING")
    ) {
      intervalId = setInterval(checkStatus, pollingInterval * 1000);
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };
  }, [onlinePaymentMetadata, orderMarkingMap]);
  const backHandler = () => {
    if (
      Object.keys(orderMarkingMap).length > 0 &&
      Object.values(orderMarkingMap).some(
        (item) =>
          item?.key === "CANCEL_DELIVERY" || item?.key === "CONFIRM_DELIVERY",
      ) &&
      onlinePaymentMetadata?.is_marking_enabled
    ) {
      setShowCancleMarkingModal(true);
      return true;
    }
    dispatch(myTaskActions.clearOrderMarking());
    return false;
  };

  const showQrPaymentOption = useMemo(
    () => allData?.multi_order_delivery && allData?.online_payment_enabled,
    [allData],
  );
  const isOrderMarkingMapEmpty = () => {
    return Object.keys(orderMarkingMap).length === 0;
  };
  const getTabStatus = () => {
    let status = null;
    if (data.card_status === "DELIVERY" && data.data_type === "TODAY") {
      status = "pending";
    }
    if (data.card_status === "RESCHEDULED" && data.data_type === "TODAY") {
      status = "rescheduled";
    }
    return status;
  };

  const markingAction = async ({ action, reason }) => {
    try {
      if (!isMarking.current) {
        isMarking.current = true;
        const payload = {
          action,
          cx_id: data.user_id,
          status: "",
          pending_order_ids:
            data?.to_be_delivered_ids || data?.delivery_pending_order_ids || [],
          reason,
          is_d_minus_2: isPendingDMinus2,
        };
        payload.status = getTabStatus();
        if (
          payload.action &&
          payload.cx_id &&
          payload.status &&
          payload.reason
        ) {
          const response = await markTaskActions(payload);
          isMarking.current = false;
          // Reschedule may be OTP-gated server-side (HTTP 200, body.status=412).
          if (response?.data?.payload?.error === "OTP_VERIFICATION_FAILED") {
            const p = response.data.payload;
            navigation.navigate("RescheduleOTPVerification", {
              otpLength: p.otpLength,
              otpText: p.errorText,
              phone_numbers: p.phone_numbers || [],
              taskPayload: payload,
              popCount: 2,
            });
            return;
          }
          navigation.goBack();
          return;
        }
        isMarking.current = false;
        navigation.goBack();
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      isMarking.current = false;
    }
  };
  const onRefresh = () => {
    setIsRefreshing(true);
    getPaymentStatus();
    setIsRefreshing(false);
  };
  const getPaymentStatus = async () => {
    try {
      const res = await getQrCodeStatus({
        cx_id: data?.user_id,
        otp_enabled: allData?.otp_enabled,
        order_ids: orderMarkingMap,
      });
      setOnlinePaymentMetadata(res?.data?.online_payment_metadata);
      if (
        allData?.online_payment_enabled &&
        res?.data?.online_payment_metadata &&
        res?.data?.online_payment_metadata?.payment_status !== "INITIAL"
      ) {
        dispatch(
          myTaskActions.addBulkOrdersMarking(
            res?.data?.online_payment_metadata?.order_marking_map,
            "api",
          ),
        );
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };
  const fetchData = async () => {
    setIsLoading(true);
    try {
      // BI-17: scope the drill-in to the trip the tapped card belongs to.
      //
      // A card that HAS a trip carries trip_id; the absence of trip_id is the
      // pending signal (the backend emits no `pending:` classifier on the boy
      // side, so there is nothing else to read). We map that absence to the
      // literal "PENDING", which the backend understands as "orders that have
      // never been given a trip".
      //
      // The two NOT_ASSIGNED sentinels are load-bearing for that branch and
      // not decoration: a never-OFD'd order has no route and no db, because
      // both are resolved off the OFD row, so the card carries neither. They
      // are pre-existing guard behaviour on the backend, not a new idiom.
      //
      // Note the sentinels are applied with ?? rather than by overwriting,
      // and that distinction is load-bearing. A pending card genuinely has no
      // route_id and no db_id, so ?? yields NOT_ASSIGNED for it — the required
      // shape. An unconditional overwrite would instead have clobbered the
      // REAL route_id/db_id of every card whenever trip_id was absent, which
      // against a pre-BI-17 backend is every card on the screen, silently
      // breaking each drill-in.
      //
      // Against such a backend no card carries a trip_id, so this reduces to
      // today's request plus one trip_id the old handler never reads: it
      // destructures only { data_type, db_id, route_id } from req.query and
      // the route has no unknown-key validator.
      const hasTrip = !!data?.trip_id;
      const res = await getUserOrders({
        user_id: data?.user_id,
        data_type: data?.data_type,
        db_id: data?.db_id ?? "NOT_ASSIGNED",
        route_id: data?.route_id ?? "NOT_ASSIGNED",
        trip_id: hasTrip ? data.trip_id : "PENDING",
      });
      isRescheduledCp.current = res?.data?.isRescheduledCp || false;
      setAllData(res?.data);
      setListData(res?.data?.tasks);
      setMultiDeliveryEnabled(res?.data?.multi_order_delivery);
      setOnlinePaymentMetadata(res?.data?.online_payment_metadata);
      res?.data?.tasks?.forEach((item) => {
        if (
          item?.card_type === "DELIVERED" ||
          item?.card_type === "RTO_CAN_CANCEL" ||
          item?.card_type === "RTO_CANNOT_CANCEL"
        ) {
          const value = {
            key: getActionKeyfn(item?.card_type),
            reason: null,
            order_id: item?.order_ids[0],
          };
          dispatch(
            myTaskActions.addOrderMarking(item?.order_ids[0], value, "api"),
          );
        }
        if (item?.order_items_count === 0) {
          const value = {
            key: "ALL_ISSUES",
            reason: null,
            order_id: item?.order_ids[0],
          };
          dispatch(
            myTaskActions.addOrderMarking(item?.order_ids[0], value, "api"),
          );
        }
      });
      if (
        res?.data?.online_payment_enabled &&
        res?.data?.online_payment_metadata &&
        res?.data?.online_payment_metadata?.payment_status !== "INITIAL"
      ) {
        dispatch(
          myTaskActions.addBulkOrdersMarking(
            res?.data?.online_payment_metadata?.order_marking_map,
            "api",
          ),
        );
      }
      if (getTabStatus()) {
        setIsRescheduled(res?.data?.any_rescheduled);
      }
      setIsPendingDMinus2(res?.data?.any_pending_d_minus_2);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };
  function getActionKeyfn(card_type) {
    if (card_type === "DELIVERED") {
      return "DELIVERED_TO_CX";
    } else if (
      card_type === "RTO_CAN_CANCEL" ||
      card_type === "RTO_CANNOT_CANCEL"
    ) {
      return "CX_RTO";
    }
    return "";
  }
  const totalPayableAmount = useMemo(
    () => calculateTotalPayableAmount(listData, orderMarkingMap),
    [listData, orderMarkingMap],
  );

  const handleNavigation = async (paymentMode = "COD") => {
    // Only set isSubmitted on actual success. Setting it on OTP failure causes
    // useFocusEffect's else-branch to fire clearOrderMarking() on every subsequent
    // markingOrder change, wiping per-order selections during a retry.
    let deliverySucceeded = false;
    try {
      if (isProcessingRef.current) return;
      isProcessingRef.current = true;
      const coords = getCachedLocation();
      const payload = {
        orders: Object.values(orderMarkingMap),
        otp: "",
        lat: coords.latitude,
        lng: coords.longitude,
        otp_enabled: allData?.otp_enabled,
        online_payment_enabled: allData?.online_payment_enabled,
        collectible_amount: parseFloat(totalPayableAmount),
        cx_user_id: listData[0]?.user_id,
        status: onlinePaymentMetadata?.status,
        amount: onlinePaymentMetadata?.amount,
        paytm_order_id: onlinePaymentMetadata?.paytm_order_id,
        payment_mode: paymentMode,
        payout_plan: allData?.payout_plan,
        ...buildDeliveryProofPayload({
          plasticBag: plasticBagDataRef.current,
          deliveryProof: deliveryProofDataRef.current,
        }),
      };
      const response = await markMultipleDeliveries(payload);
      if (response?.data?.payload?.error === "OTP_VERIFICATION_FAILED") {
        hasNavigatedToOtpRef.current = true;
        return navigation.navigate("NewOTPVerification", {
          otpLength: response?.data?.payload?.otpLength || 4,
          otpText: response?.data?.payload?.otpText || "",
          online_payment_enabled: allData?.online_payment_enabled,
          collectible_amount: totalPayableAmount,
          cx_user_id: listData[0]?.user_id,
          paymentMode,
          phone_numbers: response?.data?.payload?.phone_numbers || [],
          masked_phone_numbers:
            response?.data?.payload?.masked_phone_numbers ||
            response?.data?.payload?.phone_numbers ||
            [],
          extra_info: response?.data?.payload?.extra_info || "",
          status: onlinePaymentMetadata?.status,
          amount: onlinePaymentMetadata?.amount,
          paytm_order_id: onlinePaymentMetadata?.paytm_order_id,
          payout_plan: allData?.payout_plan,
          enable_mark_without_otp:
            response?.data?.payload?.enable_mark_without_otp,
          cancel_del_incentive_msg:
            response?.data?.payload?.cancel_del_incentive_msg,
          send_cancel_delivery_otp:
            response?.data?.payload?.send_cancel_delivery_otp || false,
          order_ids: data?.order_ids || [],
          delivery_date: allData?.date || data?.delivery_date || "",
          cx_phone_number: data?.user_phone || "",
          is_otp_request_btn_enabled:
            response?.data?.payload?.is_otp_request_btn_enabled || false,
          otp_request_reasons:
            response?.data?.payload?.otp_request_reasons || [],
          plastic_bag: plasticBagDataRef.current || undefined,
          delivery_proof: deliveryProofDataRef.current || undefined,
        });
      }
      const responsePayload = response?.data?.payload;
      if (response.status === 200) {
        deliverySucceeded = true;
        dispatch(myTaskActions.clearOrderMarking());
        if (
          responsePayload?.type === "INSTANT_COMMISSION_TRIGGERED" &&
          responsePayload?.payoutBreakdown
        ) {
          setCompleteDeliveryData(responsePayload?.payoutBreakdown);
          setShowCompleteDeliveryModal(true);
          return;
        }
        ToastMessage("success", responsePayload?.toastMessage);
      }
      fetchData();
      return navigation.pop();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("error", error);
      ToastMessage("error", "कुछ गड़बड़ी हुई, दोबारा कोशिश करें");
    } finally {
      setShowSubmitModal(false);
      isProcessingRef.current = false;
      if (deliverySucceeded) isSubmitted.current = true;
    }
  };

  const handlePaymentNavigation = async (paymentMode) => {
    // Only mark submitted when navigating to QR payment. For the COD path,
    // handleNavigation (called but not awaited below) manages isSubmitted on its
    // own — setting it here would fire clearOrderMarking() on the next markingOrder
    // change, wiping selections before the OTP retry can complete.
    let navigatedToQrPayment = false;
    try {
      if (popupConfig && !plasticBagProceedRef.current) {
        pendingPaymentModeRef.current = paymentMode;
        // Re-open the modal on every payment attempt (a failed QR/UPI attempt
        // sends the CP back to retry via COD). Pre-fill images + count from the
        // previous attempt ONLY when it belongs to THIS order, so the CP can keep
        // or edit them. React Navigation keeps this screen mounted under the
        // pushed payment/OTP screen (data survives the round-trip) but pops it on
        // a back-to-list, so re-opening any order starts fresh.
        const sameOrder =
          plasticBagOrderKeyRef.current === plasticBagOrderKey(data) &&
          plasticBagMarkingSnapshotRef.current ===
            stableMarkingSnapshot(orderMarkingMap);
        const prevProof = sameOrder ? deliveryProofDataRef.current : null;
        setDeliveryProofImages(
          prevProof?.images?.map((im) => ({
            ...im,
            id: im.id ?? uuid.v1(),
          })) ?? [],
        );
        const prevBag = sameOrder ? plasticBagDataRef.current : null;
        setPlasticBagDeliveredCount(
          prevBag?.delivered_count != null
            ? String(prevBag.delivered_count)
            : "",
        );
        setIsUploadingImage(false);
        setShowPlasticBagModal(true);
        return;
      }
      // Past the gate: the submit handler set the proceed flag so this call
      // continues to payment instead of re-opening the modal. Consume it here so
      // the NEXT user tap (e.g. a retry after payment failure) re-opens it.
      plasticBagProceedRef.current = false;
      if (paymentMode === "COD") {
        if (!showSubmitModal && !allData?.otp_enabled) {
          setShowSubmitModal(true);
        } else {
          setShowSubmitModal(false);
          handleNavigation(paymentMode);
        }
      } else {
        navigatedToQrPayment = true;
        const cx_id = data?.user_id;
        const payable_amount = totalPayableAmount;
        return navigation.navigate("CPCXQRPayment", {
          cx_id,
          payable_amount,
          otp_enabled: allData?.otp_enabled,
          payout_plan: allData?.payout_plan,
          cx_phone: data?.user_phone,
          plastic_bag: plasticBagDataRef.current || undefined,
          delivery_proof: deliveryProofDataRef.current || undefined,
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("error", error);
    } finally {
      if (navigatedToQrPayment) isSubmitted.current = true;
    }
  };
  const proceedCancelDelivery = (item) => {
    if (multiDeliveryEnabled) {
      setMarkingOrder({ ...item, key: "CANCEL_DELIVERY" });
      setShowMarkingModal(true);
    } else {
      navigation.navigate("PreDeliveryItemList", {
        orders_list: item?.order_ids,
        spoke_name: "",
        date: "",
        user_name: item?.user_name,
        user_id: item?.user_id,
        user_phone: item?.user_phone,
        is_delivery: false,
        type: "CANCEL_DELIVERY",
      });
    }
    cardMarkingBtnRef.current = false;
  };

  const onButtonPress = async (key, item) => {
    try {
      if (cardMarkingBtnRef.current) return;
      cardMarkingBtnRef.current = true;
      if (multiDeliveryEnabled) {
        if (key === "CANCEL_RTO") {
          const payload = {
            return_req_ids: item?.return_req_ids,
          };
          await cancelRto(payload);
          fetchData();
        } else if (key === "CONFIRM_DELIVERY") {
          setMarkingOrder({ ...item, key });
          setShowMarkingModal(true);
        } else if (key === "CANCEL_DELIVERY") {
          if (item?.is_escalated) {
            cardMarkingBtnRef.current = false;
            Alert.alert(
              "",
              "⚠️ कस्टमर को यह ऑर्डर चाहिए। कृपया डिलीवरी की कोशिश करें। क्या आप अभी भी इसे RTO मार्क करना चाहते हैं?",
              [
                { text: "Cancel", style: "cancel" },
                {
                  text: "Yes, Raise CX RTO",
                  onPress: () => proceedCancelDelivery(item),
                },
              ],
            );
            return;
          }
          proceedCancelDelivery(item);
        }
      } else {
        if (key === "CONFIRM_DELIVERY") {
          return navigation.navigate("PreDeliveryItemList", {
            orders_list: item?.order_ids,
            spoke_name: "",
            date: "",
            user_name: item?.user_name,
            user_id: item?.user_id,
            user_phone: item?.user_phone,
            is_delivery: true,
            afterOtpRedirectScreenName: "MyTask",
            type: "CONFIRM_DELIVERY",
          });
        } else if (key === "CANCEL_DELIVERY") {
          if (item?.is_escalated || data?.is_escalated) {
            cardMarkingBtnRef.current = false;
            Alert.alert(
              "",
              "⚠️ कस्टमर को यह ऑर्डर चाहिए। कृपया डिलीवरी की कोशिश करें। क्या आप अभी भी इसे RTO मार्क करना चाहते हैं?",
              [
                { text: "Cancel", style: "cancel" },
                {
                  text: "Yes, Raise CX RTO",
                  onPress: () => proceedCancelDelivery(item),
                },
              ],
            );
            return;
          }
          proceedCancelDelivery(item);
          return;
        } else if (key === "CANCEL_RTO") {
          const payload = {
            return_req_ids: item?.return_req_ids,
          };
          await cancelRto(payload);
          fetchData();
        }
      }
    } catch {
    } finally {
      cardMarkingBtnRef.current = false;
    }
  };
  const onMarkingOrder = (orderId, value) => {
    if (value) {
      dispatch(myTaskActions.addOrderMarking(orderId, value, "button"));
    } else {
      dispatch(myTaskActions.removeOrderMarking(orderId));
    }
  };
  const checkAllCxRTO = () => {
    if (
      Object.keys(orderMarkingMap).length === 0 ||
      Object.keys(orderMarkingMap).length < listData.length
    ) {
      return false;
    }
    let val = true;
    Object.values(orderMarkingMap).forEach((item) => {
      if (item?.key === "CONFIRM_DELIVERY") {
        val = false;
      }
    });
    return val;
  };
  const getSubmitBtnText = useCallback(() => {
    if (allData?.otp_enabled) {
      if (!checkAllCxRTO()) {
        return t(`${PATH}/submit_with_otp`);
      }
      return t(`${PATH}/submit`);
    }
    return t(`${PATH}/submit`);
  }, [orderMarkingMap, allData?.otp_enabled]);
  const renderItem = useCallback(
    ({ item }) => {
      return (
        <InnerDeliveryCard
          item={item}
          onPressBtn={onButtonPress}
          orderMarkingMap={orderMarkingMap}
          onMarkingOrder={onMarkingOrder}
          cardMarkingBtnRef={cardMarkingBtnRef}
          changeMarkingEnabled={onlinePaymentMetadata?.is_marking_enabled}
        />
      );
    },
    [
      orderMarkingMap,
      multiDeliveryEnabled,
      onlinePaymentMetadata?.is_marking_enabled,
    ],
  );
  const onSubmit = () => {
    setShowSubmitModal(true);
  };
  const modalImage = (type) => {
    switch (type) {
      case "submit":
        return <ModalSubmit />;
      case "cancel":
        return <ModalCancel />;
      case "cash":
        return <ModalCashCollection />;
      default:
        return <ModalSubmit />;
    }
  };
  const closemarkingModal = async () => {
    setShowMarkingModal(false);
    await fetchData();
  };
  const footerComponent = () => <View style={styles.footer} />;

  const popupConfig = allData?.popup_config ?? null;
  const maxImageCount = popupConfig?.max_image_count || 6;
  const manualInputRequired = !!popupConfig?.manual_input_required;
  const imageUploadDisabled = !!popupConfig?.image_upload_disabled;
  // Resolved once per render from both server tiers; "OFF" (the default when
  // either tier is absent) makes imagePickerHelper use the system camera
  // exactly as before.
  const validationConfig = useMemo(
    () =>
      resolveValidationConfig({
        popupConfig,
        appSettings,
        versionCode: Number(getBuildNumber()) || 0,
      }),
    [popupConfig, appSettings],
  );
  // Unrelated reminder banner (DEFERRED — not this feature's popup); still
  // reads the legacy allData?.plastic_bag_count field the backend continues
  // to send.
  const plasticBagCount = Number(allData?.plastic_bag_count) || 0;
  const plasticBagBanner =
    allData?.plastic_bag_opted_in && plasticBagCount > 0 ? (
      <View style={styles.plasticBagBanner}>
        <Text variant="body_text_2" style={styles.plasticBagText}>
          {t(
            `${PATH}/${plasticBagCount === 1 ? "plastic_bag_required_singular" : "plastic_bag_required_plural"}`,
            { count: plasticBagCount },
          )}
        </Text>
      </View>
    ) : null;

  const isAllOrderMarkingSourceAPI = () => {
    if (
      onlinePaymentMetadata?.payment_status !== "FAILED" ||
      onlinePaymentMetadata?.payment_status !== "EXPIRED"
    )
      return false;
    if (
      Object.keys(orderMarkingSource).length === 0 ||
      Object.keys(orderMarkingSource).length < listData.length
    ) {
      return false;
    }
    let val = true;
    Object.values(orderMarkingSource).forEach((item) => {
      if (item !== "api") {
        val = false;
      }
    });
    return val;
  };

  // The ONLY camera call for the delivery-proof popup (parent-owned so the
  // single imagePickerHelper/getCachedLocation wiring is reused by the
  // presentational grid). Functional setState throughout avoids stale
  // closures across the async upload callbacks.
  const handleAddDeliveryImage = () => {
    if (deliveryProofImages.length >= maxImageCount) return;
    const id = uuid.v1();
    imagePickerHelper({
      source: "camera",
      validationConfig,
      onSelectCallback: (response) => {
        if (!response?.uri) return;
        setIsUploadingImage(true);
        setDeliveryProofImages((prev) => [
          ...prev,
          { id, localUri: response.uri, uploading: true },
        ]);
      },
      onSuccessCallback: (uploadData) => {
        // The per-image geotag is a synchronous cache read, so it lands in the
        // SAME state update that clears `uploading` — no background pass, no
        // way for the tile to get stuck at `uploading: true` waiting on GPS.
        //
        // Isolated in its own try/catch on purpose: imagePickerHelper invokes
        // this callback INSIDE its own try block, so anything thrown here is
        // caught there, reported to the DB as "Error with uploading image",
        // and passed to onErrorCallback — which deletes the tile. By this
        // point the photo has ALREADY uploaded successfully. A geotag must
        // never be able to discard a good upload, so it degrades to null
        // coords instead of throwing.
        let coords = null;
        try {
          coords = getCachedLocation();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log("[delivery-proof] geotag read failed", e);
        }
        // Same reasoning as the geotag above: a verdict read must never be
        // able to throw into onErrorCallback, which deletes a tile whose photo
        // has already uploaded. Absent on every path where validation is off.
        const validation = uploadData?.validation ?? null;
        setDeliveryProofImages((prev) =>
          prev.map((im) =>
            im.id === id
              ? {
                  ...im,
                  url: uploadData?.url ?? null,
                  uploading: false,
                  uploaded_at: new Date().toISOString(),
                  lat: coords?.latitude ?? null,
                  lng: coords?.longitude ?? null,
                  validation,
                }
              : im,
          ),
        );
        if (validation && validation.verdict !== "PASS") {
          try {
            // The event that tells us we mis-tuned a threshold. FORCED means the
            // DB pushed past the gate; SKIPPED means nothing could be evaluated.
            analytics.trackEvent(
              validation.verdict === "FORCED"
                ? "Delivery Proof Image Forced"
                : "Delivery Proof Image Skipped",
              {
                popup_variant: popupConfig?.popup_variant ?? null,
                mode: validation.mode,
                attempts: validation.attempts,
                failed: (validation.failed || []).join(","),
                ml_skipped: validation.ml_skipped,
                blur: validation.scores?.blur ?? null,
                luma: validation.scores?.luma ?? null,
              },
            );
          } catch (_e) {
            // ignore analytics failures
          }
        }
        setIsUploadingImage(false);
      },
      onErrorCallback: (e) => {
        // Fires for a genuine upload failure AND for anything thrown by
        // onSelectCallback/onSuccessCallback. Log the cause — otherwise the
        // two are indistinguishable from the "Error with uploading image"
        // toast alone.
        // eslint-disable-next-line no-console
        console.log("[delivery-proof] image capture/upload failed", e);
        setDeliveryProofImages((prev) => prev.filter((im) => im.id !== id));
        setIsUploadingImage(false);
      },
    });
  };

  const handleRemoveDeliveryImage = (id) =>
    setDeliveryProofImages((prev) => prev.filter((im) => im.id !== id));

  // imageUploadDisabled waives the >=1-image requirement — the grid is
  // hidden in that case, so submit would otherwise be permanently disabled.
  // Gate on the SAME predicate onPopupSubmit uses to build the payload
  // (im.url truthy) — checking raw tile count instead let an in-flight or
  // failed-but-not-yet-purged tile keep submit enabled while the payload's
  // own `.filter((im) => im.url)` shipped an empty/short `delivery_proof`.
  const hasEnoughImages =
    imageUploadDisabled || deliveryProofImages.some((im) => im.url);
  const countOk = !manualInputRequired || plasticBagDeliveredCount !== "";
  // isUploadingImage is a single flag set by whichever capture's
  // onSelectCallback/onSuccessCallback/onErrorCallback last touched it. On
  // slow networks a second capture can start before the first one's upload
  // settles, so when the FIRST tile's callback fires it flips this back to
  // `false` even though a DIFFERENT tile is still `{uploading: true}` —
  // capture isn't serialized against upload completion. Derive the real
  // "any capture still in flight" signal from the tiles themselves so
  // submit stays disabled until every tile has settled, not just the
  // most-recently-touched one (otherwise onPopupSubmit's own
  // `.filter((im) => im.url)` silently drops the still-uploading tile).
  const anyStillUploading = deliveryProofImages.some((im) => im.uploading);
  const submitEnabled =
    hasEnoughImages && !isUploadingImage && !anyStillUploading && countOk;
  const isUploadingDeliveryProof = anyStillUploading;

  const onPopupSubmit = () => {
    const images = deliveryProofImages
      .filter((im) => im.url)
      .map(({ url, lat, lng, uploaded_at, validation }) => ({
        url,
        lat: lat ?? null,
        lng: lng ?? null,
        uploaded_at,
        // Omitted entirely rather than sent as null when validation is off, so
        // the payload shape is unchanged for every CP that has not enabled it.
        ...(validation ? { validation } : {}),
      }));
    try {
      analytics.trackEvent("Plastic Bag Popup Submit", {
        popup_variant: popupConfig?.popup_variant ?? null,
        images_count: images.length,
      });
    } catch (_e) {
      // ignore analytics failures
    }
    deliveryProofDataRef.current = {
      popup_variant: popupConfig?.popup_variant,
      images,
    };
    plasticBagDataRef.current = manualInputRequired
      ? {
          opted_in: true,
          delivered: true,
          count: popupConfig?.required_count ?? null,
          delivered_count: Number(plasticBagDeliveredCount),
        }
      : null;
    plasticBagOrderKeyRef.current = plasticBagOrderKey(data);
    plasticBagMarkingSnapshotRef.current =
      stableMarkingSnapshot(orderMarkingMap);
    plasticBagProceedRef.current = true;
    setShowPlasticBagModal(false);
    const mode = pendingPaymentModeRef.current;
    pendingPaymentModeRef.current = null;
    handlePaymentNavigation(mode);
  };

  return (
    <View style={styles.container}>
      <HeaderWithBackAndTitle
        headertitle={data?.user_name || t(`${PATH}/customer_orders`)}
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        route={route}
        alwaysEnable={true}
        goingBackHandler={
          multiDeliveryEnabled &&
          Object.keys(orderMarkingMap).length > 0 &&
          Object.values(orderMarkingMap).some(
            (item) =>
              item?.key === "CANCEL_DELIVERY" ||
              item?.key === "CONFIRM_DELIVERY",
          ) &&
          onlinePaymentMetadata?.is_marking_enabled
            ? backHandler
            : null
        }
        rightComponent={
          isRescheduledCp.current ? (
            <RescheduleRightComponent
              isRescheduled={isRescheduled}
              setRescheduledModal={setRescheduledModal}
            />
          ) : null
        }
        bottomComponent={
          allData?.should_deliver_tag && (
            <HeaderStrip should_deliver_tag={allData?.should_deliver_tag} />
          )
        }
      />
      {allData?.amount_to_collect_today > 0 && !multiDeliveryEnabled ? (
        <View style={styles.moneyBox}>
          <Text variant="body_text_1" style={{ color: color.plain_green }}>
            {t(`${PATH}/amount_to_collect`)}
          </Text>
          <Text variant="heading_24" style={styles.amountText}>
            ₹ {Math.abs(allData?.amount_to_collect_today)}
          </Text>
        </View>
      ) : null}
      <View style={styles.container}>
        <FlatList
          data={listData}
          renderItem={({ item }) => renderItem({ item })}
          keyExtractor={(item) => item.card_id}
          keyboardShouldPersistTaps="handled"
          ListFooterComponent={footerComponent}
          onRefresh={onRefresh}
          refreshing={isRefreshing}
        />

        {showQrPaymentOption && !checkAllCxRTO() ? (
          <BottomPaymentSheet
            disable={
              isOrderMarkingMapEmpty() ||
              isMarking.current ||
              Object.keys(orderMarkingMap).length !== listData.length ||
              isAllOrderMarkingSourceAPI()
            }
            onPress={handlePaymentNavigation}
            amount={totalPayableAmount}
            online_payment_metadata={onlinePaymentMetadata}
            buttons={[
              { Icon: CashIcon, text: "कैश पेमेंट", paymentMode: "COD" },
              { Icon: QRIcon, text: "UPI पेमेंट", paymentMode: "PREPAID" },
            ]}
            handleNavigation={handleNavigation}
            refresh={onRefresh}
            topAccessory={plasticBagBanner}
          />
        ) : allData?.show_delivery_submit_button && multiDeliveryEnabled ? (
          <BottomButton
            onPress={onSubmit}
            title={getSubmitBtnText()}
            amount={totalPayableAmount}
            showPaymentText={
              Object.keys(orderMarkingMap).length === listData.length &&
              !checkAllCxRTO()
            }
            loading={false}
            disable={
              isOrderMarkingMapEmpty() ||
              isProcessingRef.current ||
              Object.keys(orderMarkingMap).length !== listData.length ||
              isAllOrderMarkingSourceAPI()
            }
            topAccessory={plasticBagBanner}
          />
        ) : null}
        <Modal
          visible={isloading}
          transparent={true}
          statusBarTranslucent
          navigationBarTranslucent
        >
          <View style={styles.loadingView}>
            <ActivityIndicator size="large" color={color.primary} />
          </View>
        </Modal>
        <RescheduleModal
          isPendingDMinus2={isPendingDMinus2}
          rescheduledModal={rescheduledModal}
          isRescheduled={isRescheduled}
          setRescheduledModal={setRescheduledModal}
          markingAction={markingAction}
          selectedAction={data.action}
          taskActionConfig={allData?.task_action_config}
        />
      </View>
      <MarkingDeliveryModal
        showModal={showMarkingModal}
        setShowModal={setShowMarkingModal}
        item={markingOrder}
        onMarkingOrder={onMarkingOrder}
        closemarkingModal={closemarkingModal}
      />
      <ConfirmationModalWithImage
        imageComponent={modalImage("submit")}
        text={
          !checkAllCxRTO()
            ? t(`${PATH}/submit_modal_text`)
            : t(`${PATH}/submit_modal_text_2`)
        }
        visible={showSubmitModal}
        setVisible={setShowSubmitModal}
        buttonText={[
          {
            text: t(`${PATH}/no`),
            type: "cancel",
            onPress: () => setShowSubmitModal(false),
          },
          {
            text: t(`${PATH}/yes`),
            type: "submit",
            onPress: handleNavigation,
          },
        ]}
      />
      <ConfirmationModalWithImage
        imageComponent={modalImage("cancel")}
        text={t(`${PATH}/cancle_modal_text`)}
        visible={showCancleMarkingModal}
        setVisible={setShowCancleMarkingModal}
        buttonText={[
          {
            text: t(`${PATH}/no`),
            type: "cancel",
            onPress: () => setShowCancleMarkingModal(false),
          },
          {
            text: t(`${PATH}/yes`),
            type: "submit",
            onPress: () => {
              dispatch(myTaskActions.clearOrderMarking());
              setShowCancleMarkingModal(false);
              navigation.pop();
            },
          },
        ]}
      />
      {popupConfig ? (
        <Modal
          animationType="fade"
          transparent={true}
          visible={showPlasticBagModal}
          onRequestClose={() => setShowPlasticBagModal(false)}
          statusBarTranslucent
          navigationBarTranslucent
        >
          <KeyboardAvoidingView
            style={styles.container}
            behavior={Platform.OS === "ios" ? "padding" : "height"}
          >
            <View style={styles.modalOverlay}>
              <View style={styles.plasticBagInputModal}>
                {/* HEADER ROW: title left, close (X) right */}
                <View style={styles.plasticBagModalHeader}>
                  <Text
                    variant="body_text_4"
                    style={styles.plasticBagModalTitle}
                  >
                    {popupConfig.title}
                  </Text>
                  <TouchableOpacity
                    style={styles.plasticBagCloseBtn}
                    onPress={() => {
                      setShowPlasticBagModal(false);
                      setDeliveryProofImages([]);
                      setPlasticBagDeliveredCount("");
                    }}
                  >
                    <CloseIcon
                      width={18}
                      height={18}
                      fill={color.mediumBlack}
                    />
                  </TouchableOpacity>
                </View>

                {/* ══ TOP HALF (both P1 & P2) ══ */}
                {popupConfig.pre_image_text ? (
                  <Text
                    variant="caption_2"
                    style={styles.deliveryProofPreImageText}
                  >
                    {popupConfig.pre_image_text}
                  </Text>
                ) : null}

                {popupConfig.text1 ? (
                  <Text variant="caption_2" style={styles.deliveryProofText1}>
                    {popupConfig.text1}
                  </Text>
                ) : null}

                {!imageUploadDisabled ? (
                  <DeliveryProofImageGrid
                    images={deliveryProofImages}
                    maxCount={maxImageCount}
                    onAddPress={handleAddDeliveryImage}
                    onRemove={handleRemoveDeliveryImage}
                  />
                ) : null}

                {/* ══ BOTTOM HALF — P1 only ══ */}
                {manualInputRequired ? (
                  <>
                    {popupConfig.required_count_text ? (
                      <View style={styles.plasticBagRequiredChip}>
                        <Text
                          variant="caption_2"
                          style={styles.plasticBagRequiredChipText}
                        >
                          {popupConfig.required_count_text}
                        </Text>
                      </View>
                    ) : null}

                    {popupConfig.count_label ? (
                      <Text
                        variant="caption_2"
                        style={styles.plasticBagCountLabel}
                      >
                        {popupConfig.count_label}
                      </Text>
                    ) : null}

                    <TextInput
                      style={styles.plasticBagCountInput}
                      keyboardType="number-pad"
                      value={plasticBagDeliveredCount}
                      onChangeText={(v) => {
                        const clean = v.replace(/[^0-9]/g, "");
                        setPlasticBagDeliveredCount(clean);
                      }}
                      placeholder={"0"}
                      maxLength={4}
                    />

                    {popupConfig.text2 ? (
                      <Text
                        variant="caption_2"
                        style={styles.deliveryProofText2}
                      >
                        {popupConfig.text2}
                      </Text>
                    ) : null}
                  </>
                ) : null}

                {isUploadingDeliveryProof ? (
                  <View style={styles.uploadingInfoRow}>
                    <ActivityIndicator
                      size="small"
                      color={color.primary}
                      style={styles.uploadingIndicator}
                    />
                    <Text variant="caption_2" style={styles.uploadingInfoText}>
                      {t(`${PATH}/uploading_images`)}
                    </Text>
                  </View>
                ) : null}

                {/* SUBMIT BUTTON — shared, last */}
                <TouchableOpacity
                  style={[
                    styles.plasticBagSubmitBtn,
                    !submitEnabled && styles.plasticBagSubmitBtnDisabled,
                  ]}
                  disabled={!submitEnabled}
                  onPress={onPopupSubmit}
                >
                  <Text
                    variant="body_text_2"
                    style={styles.plasticBagSubmitBtnText}
                  >
                    {t(`${PATH}/submit`)}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </KeyboardAvoidingView>
        </Modal>
      ) : null}
      <CompleteDelivery
        isVisible={showCompleteDeliveryModal}
        onClose={() => {
          setShowCompleteDeliveryModal(false);
          navigation.pop(1);
        }}
        completeDeliveryData={completeDeliveryData}
      />
    </View>
  );
}

export default CustomerOrdersView;

const PALETTE = {
  moneyBoxBg: "rgba(0, 171, 89, 0.05)",
  headerStripBg: "rgba(255, 249, 248, 1)",
};

const styles = StyleSheet.create({
  plasticBagBanner: {
    backgroundColor: color.lightYellow,
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
    marginBottom: 10,
  },
  plasticBagText: {
    color: color.light_text_yellow,
  },
  container: {
    flex: 1,
  },
  loadingView: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  footer: {
    height: 200,
  },
  amountText: {
    color: color.plain_green,
    fontSize: 32,
    marginTop: 10,
  },
  moneyBox: {
    backgroundColor: PALETTE.moneyBoxBg,
    borderWidth: 1,
    borderRadius: 10,
    borderColor: color.plain_green,
    margin: 10,
    marginHorizontal: 16,
    alignItems: "center",
    padding: 12,
  },
  headerStrip: {
    flexDirection: "row",
    backgroundColor: PALETTE.headerStripBg,
    paddingVertical: 6,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    elevation: 1,
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  headerText: {
    color: color.mediumBlacklightBlack,
    marginLeft: 8,
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: color.modalBackground,
    justifyContent: "center",
    alignItems: "center",
  },
  plasticBagInputModal: {
    backgroundColor: color.white,
    borderRadius: 20,
    padding: 20,
    width: width - 48,
    alignItems: "center",
  },
  plasticBagModalTitle: {
    fontWeight: "700",
    flex: 1,
  },
  deliveryProofPreImageText: {
    alignSelf: "stretch",
    color: color.mediumBlack,
    marginBottom: 6,
  },
  deliveryProofText1: {
    alignSelf: "stretch",
    color: color.mediumBlack,
    marginBottom: 10,
  },
  plasticBagCountLabel: {
    alignSelf: "stretch",
    marginBottom: 6,
    color: color.mediumBlack,
  },
  plasticBagCountInput: {
    borderWidth: 1,
    borderColor: color.lighterBlack,
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    width: "100%",
    marginBottom: 20,
    fontSize: 16,
    color: color.mediumBlack,
  },
  plasticBagSubmitBtn: {
    backgroundColor: color.btnGreen,
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 24,
    width: "100%",
    alignItems: "center",
  },
  plasticBagSubmitBtnDisabled: {
    opacity: 0.4,
  },
  plasticBagSubmitBtnText: {
    color: color.white,
  },
  uploadingInfoRow: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 12,
    marginBottom: 8,
  },
  uploadingIndicator: {
    marginRight: 8,
  },
  uploadingInfoText: {
    color: color.mediumBlack,
  },
  plasticBagModalHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: 10,
  },
  plasticBagCloseBtn: {
    padding: 4,
  },
  plasticBagRequiredChip: {
    backgroundColor: color.lightYellow,
    borderRadius: 6,
    paddingHorizontal: 10,
    paddingVertical: 4,
    alignSelf: "flex-start",
    marginBottom: 12,
  },
  plasticBagRequiredChipText: {
    color: color.light_text_yellow,
  },
  deliveryProofText2: {
    alignSelf: "stretch",
    color: color.errorRed,
    marginTop: 4,
    marginBottom: 8,
  },
});
